// Global confirm dialog. Pakai `useConfirm()` di mana saja, dan komponen
// <ConfirmDialog/> di-mount sekali di layout root supaya satu antrian saja.
//
//   const { confirm } = useConfirm()
//   if (!(await confirm({ title: 'Hapus?', message: '…', tone: 'danger' }))) return
//
// Tujuan: ganti window.confirm() yg jelek dengan modal terstandarisasi.

export interface ConfirmOptions {
  title?: string
  message: string
  detail?: string                // optional detail line (gray, italic) di bawah message
  confirmLabel?: string
  cancelLabel?: string
  tone?: 'danger' | 'warning' | 'primary'
  // Kalau true → cancel button disembunyikan (cuma OK), berfungsi sebagai alert.
  alertOnly?: boolean
}

interface ConfirmState extends ConfirmOptions {
  open: boolean
  resolve: ((v: boolean) => void) | null
}

const state = reactive<ConfirmState>({
  open: false,
  message: '',
  resolve: null,
})

export function useConfirm() {
  function confirm(opts: ConfirmOptions): Promise<boolean> {
    return new Promise((resolve) => {
      state.title        = opts.title        ?? 'Konfirmasi'
      state.message      = opts.message
      state.detail       = opts.detail
      state.confirmLabel = opts.confirmLabel ?? 'Lanjutkan'
      state.cancelLabel  = opts.cancelLabel  ?? 'Batal'
      state.tone         = opts.tone         ?? 'primary'
      state.alertOnly    = !!opts.alertOnly
      state.resolve      = resolve
      state.open         = true
    })
  }
  function alert(message: string, opts: Partial<ConfirmOptions> = {}): Promise<void> {
    return confirm({ ...opts, message, alertOnly: true, confirmLabel: opts.confirmLabel ?? 'OK' }).then(() => undefined)
  }
  return { confirm, alert, _state: state }
}
